import { memo, useCallback } from 'react';
import { Text, Icon, useTheme } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';
import { getLiteral } from 'utils/getLiteral';

const DanaBoxOption = ({ option, textLength, onClick }) => {
    const theme = useTheme();
    const isDisabled = textLength < option.limit && option.limit;
    const rootClassName = classnames('fm-ee__dana-box__option', {
        'fm-ee__dana-box__option--disabled': isDisabled,
    });

    const onClickOption = useCallback(() => {
        onClick(option);
    }, [onClick, option]);

    return (
        <div
            key={option.id}
            className={rootClassName}
            onClick={isDisabled ? undefined : onClickOption}
        >
            {option.icon}
            <Text
                className="fm-ee__dana-box__option__label"
                color={
                    isDisabled
                        ? theme.colors.utility.textDisabled
                        : theme.colors.utility.textPrimary
                }
            >
                {getLiteral(option.label)}
            </Text>
            {isDisabled && (
                <div className="fm-ee__dana-box__option__warning">
                    <Icon name="warning" color={theme.colors.semantic.focus500} />
                    <Text type="caption" color={theme.colors.textLight.primary}>
                        {getLiteral('label_content_too_brief')}
                    </Text>
                </div>
            )}
        </div>
    );
};

export default memo(DanaBoxOption);
